import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';
import getColor from './colors';
import './styles.css';
import he from './assets/Avatar_he-x60@3x.png';
import hs from './assets/Avatar_hs-x60@3x.png';

/**
  * Avatar Component
  *
  * Per the style guide Avatars for institutions should render their logo, square,
  * and default to the university icon.
  *
  * Avatars for People should render their profile picture, circular,
  * and default to a randomly colored circle with their initials
  *
  * Props:
  *  - image: {string} the source image
  *  - institutionType: {enum}: 'he', 'HE', 'hs', 'HS' *** defaults to 'hs'
  *  - institutionId {string}: the institution id to look up for the logo
  *  - size: {enum}: 'small', 'medium', 'large', 'stretch' **** defaults to 'small'
  *  - fullName: {string}: 'User's full name, first and last'
  *  - user: {bool} Avatar is a user or not **** This will make the Avatar round ****
*/

const AVATAR_URL = 'https://static.naviance.com/libraries/college-logos/%%__INSITUTION_ID__%%.gif';
const REPLACE_TOKEN = '%%__INSITUTION_ID__%%';

class Avatar extends React.PureComponent {
  static propTypes = {
    image: PropTypes.string,
    institutionType: PropTypes.oneOf(['he', 'HE', 'hs', 'HS']),
    size: PropTypes.oneOf(['large', 'medium', 'small', 'stretch']),
    fullName: PropTypes.string,
    user: PropTypes.bool,
    institutionId: PropTypes.string,
  };

  constructor(props) {
    super(props);

    const _state = {
      src: props.image,
    };

    if (props.institutionId) {
      _state.src = AVATAR_URL.replace(REPLACE_TOKEN, props.institutionId);
    }

    this.state = _state;
  }

  onImageError = () => {
    this.setState({
      src: '', // render icon instead
    });
  };

  render() {
    const { user, institutionType, size = 'small', fullName } = this.props;
    const { src } = this.state;
    const styles = `avatar ${size}${user ? ' user' : ''}`;

    if (src) {
      return (
        <Image
          aria-hidden="true"
          src={src}
          styleName={styles}
          onError={this.onImageError}
        />
      );
    } else if (!user) {
      const icon = (institutionType === 'he' || institutionType === 'HE') ? he : hs;
      return (
        <Image
          aria-hidden="true"
          src={icon}
          styleName={styles}
        />
      );
    } else {
      const initials = fullName ? fullName.split(' ').filter((c) => c).map((c) => c[0].toUpperCase()).join('') : '';
      return (
        <span styleName={`${styles} ${getColor(fullName)}`}>
          {initials}
        </span>
      );
    }
  }
}

export default Avatar;
